// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__form_control {
  width: 100%;
}
.__form_control .__label {
  font-size: 14px;
}
.__form_control .__info {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
}
.__form_control .__social_inputbox {
  position: relative !important;
}
.__form_control .__social_inputbox .__input {
  padding-left: 50px;
  border-radius: 25px !important;
  height: 50px !important;
  background-color: #171515 !important;
}
.__form_control .__social_inputbox .__input fieldset {
  border-color: #262626 !important;
}
.__form_control .__social_inputbox .__input_icon {
  position: absolute;
  left: 24px;
  top: 14px;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/SocialInput/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAAE;EACE,eAAA;AAEJ;AAAE;EACE,eAAA;EACA,+BAAA;AAEJ;AAAE;EACE,6BAAA;AAEJ;AAAI;EACE,kBAAA;EACA,8BAAA;EACA,uBAAA;EACA,oCAAA;AAEN;AAAM;EACE,gCAAA;AAER;AAEI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AAAN","sourcesContent":[".__form_control {\n  width: 100%;\n  .__label {\n    font-size: 14px;\n  }\n  .__info {\n    font-size: 13px;\n    color: #ffffffcc;\n  }\n  .__social_inputbox {\n    position: relative !important;\n\n    .__input {\n      padding-left: 50px;\n      border-radius: 25px !important;\n      height: 50px !important;\n      background-color: #171515 !important;\n\n      fieldset {\n        border-color: #262626 !important;\n      }\n    }\n\n    .__input_icon {\n      position: absolute;\n      left: 24px;\n      top: 14px;\n      z-index: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
